import React, { memo } from 'react';
import { Button } from './Button';
export function HeroSection() {
  return <section className="bg-amber-50 py-16 md:py-24 px-4" data-id="element-111">
      <div className="max-w-4xl mx-auto text-center" data-id="element-112">
        <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-stone-900 mb-6 leading-tight" data-id="element-113">
          ¿Siente que su memoria le está fallando o es "solo la edad"?
        </h1>
        <h2 className="text-xl md:text-2xl text-stone-700 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-114">
          Recupere la agilidad mental de hace 20 años y proteja su independencia
          con el método de "Neuro-Gimnasia Hispana" diseñado para la mujer de
          hoy.
        </h2>
        <div className="mb-10 flex justify-center" data-id="element-115">
          <img src="https://cdn.magicpatterns.com/uploads/hUosK1GzFoJxwPQmiiGqeN/heylloyd-image-Memoria_de_oro.png" alt="Memoria de Oro - Guía Anti-Olvidos en tableta y teléfono" className="rounded-2xl shadow-2xl max-w-full h-auto md:max-w-2xl object-cover" data-id="element-116" />
        </div>
        <Button href="#precio" data-id="element-117">Quiero Mi Guía Ahora — $6.36</Button>
      </div>
    </section>;
}